import classNames from 'classnames'
import styles from './AddClientModal.module.css'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../redux/store'
import { getRole } from '../../../utils/getRole'
import ModalImage from 'react-modal-image'

import {
  Client,
  fetchEditClient,
  setIsVisibleModalClient,
} from '../../../redux/reducers/clients'
import { clientsSelector } from '../../../redux/selectors/clients-selector'
import {
  fetchAddPhones,
  fetchPhones,
  Phone,
  setCurrentPhone,
  setVisibleDeleteModalPhone,
} from '../../../redux/reducers/phones'
import { phonesSelector } from '../../../redux/selectors/phones-selector'
import { useClearBodyNoScrollClass } from '../../../hooks/use-clear-body-no-scroll-slass'
import { convertFileIfHeic } from '../../../utils/heicUtils'
import { toast } from 'react-toastify'
import { fetchCountries } from '../../../redux/reducers/countries'
import { fetchCities } from '../../../redux/reducers/cities'
import { citiesSelector } from '../../../redux/selectors/cities-selector'
import { countriesSelector } from '../../../redux/selectors/countries-selector'
import { formatDate } from '../../../utils/date'

const { isAdmin, isOwner } = getRole()

const roles = [
  { role: 'Водитель', value: 'driver' },
  { role: 'Админ', value: 'admin' },
]

const currencies = [
  { label: 'BYN', value: 'BYN' },
  { label: 'EUR', value: 'EUR' },
  { label: 'RUB', value: 'RUB' },
  { label: 'USD', value: 'USD' },
]

const MainInfo = ({
  isActive,
  setIsActive,
  district,
  setDistrict,
  address,
  setAddress,
  entity,
  setEntity,
  entityName,
  setEntityName,
  name,
  setName,
  email,
  setEmail,
  setCurrency,
  currency,
  phones,
  setPhones,
  countryIso,
  setCountryIso,
  countryName,
  setCountryName,
  cityId,
  setCityId,
  cityName,
  setCityName,
  logo,
  handleImageChange,
  errors,
  setErrors,
  contracts,
  selectedContractId,
  setSelectedContractId,
  currentClientByRequest,
}: any) => {
  const dispatch = useDispatch<AppDispatch>()

  const [newNumber, setNewNumber] = useState('')
  const [newName, setNewName] = useState('')
  const [newEmail, setNewEmail] = useState('')

  const [newJob, setNewJob] = useState('')
  const [newNotification, setNewNotification] = useState(false)
  const [isVisibleAddPhone, setIsVisibleAddPhone] = useState(false)

  const [isWasChanged, setIsWasChanged] = useState<null | number>(null)

  const { cities } = useSelector(citiesSelector)
  const { countries } = useSelector(countriesSelector)

  const handleSelectChangeCountry = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setCountryIso(event.target.value)

    const find = countries?.find((item) => item.iso === event.target.value)
    setCountryName(find?.name)
  }

  const handleSelectChangeCity = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setCityId(event.target.value)

    const find = cities?.find((item) => String(item.id) === event.target.value)
    setCityName(find?.name)
    // if (event.target.value === '1') {

    //   setCityName('Москва')
    // } else if (event.target.value === '2') {
    //   setCityId(event.target.value)

    //   setCityName('Брест')
    // } else {
    //   setCityId(undefined)

    //   setCityName(undefined)
    // }
  }

  const handleChange = (event: { target: { value: string } }) => {
    setEntity(event.target.value !== 'individual')
  }

  const handleNumberChange = (id: number, newNumber: string) => {
    setIsWasChanged(id)
    setPhones(
      phones.map((phone: Phone) =>
        phone.id === id ? { ...phone, number: newNumber } : phone
      )
    )
  }

  const handleNameChange = (id: number, newName: string) => {
    setIsWasChanged(id)

    setPhones(
      phones.map((phone: Phone) =>
        phone.id === id ? { ...phone, name: newName } : phone
      )
    )
  }

  const handleEmailChange = (id: number, newEmail: string) => {
    setIsWasChanged(id)

    setPhones(
      phones.map((phone: Phone) =>
        phone.id === id ? { ...phone, email: newEmail } : phone
      )
    )
  }

  const handleJobChange = (id: number, newJob: string) => {
    setIsWasChanged(id)

    setPhones(
      phones.map((phone: Phone) =>
        phone.id === id ? { ...phone, job: newJob } : phone
      )
    )
  }

  const handleNotificationChange = (id: number, newNotification: boolean) => {
    setIsWasChanged(id)

    setPhones(
      phones.map((phone: Phone) =>
        phone.id === id ? { ...phone, notification: newNotification } : phone
      )
    )
  }

  const handleAddPhone = () => {
    dispatch(
      fetchAddPhones({
        name: newName,
        email: newEmail,
        number: newNumber,
        notification: newNotification,
        job: newJob,
      })
    )

    setNewNumber('')
    setNewName('')
    setNewJob('')
    setNewEmail('')
    setNewNotification(false)
    setIsVisibleAddPhone(false)
  }

  const handleEditPhone = (item: Phone) => {
    dispatch(fetchAddPhones({ ...item }))
  }

  const handleInputChange =
    (setter: React.Dispatch<React.SetStateAction<string>>, field: string) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setter(e.target.value)
      //@ts-ignore
      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: !!e.target.value ? false : true,
      }))
    }

  useEffect(() => {
    dispatch(fetchCountries())
    dispatch(fetchCities())
  }, [])

  return (
    <>
      <div className="mb-5">
        <div className="row mb-3">
          <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3">
            <div className={styles.loadPhoto}>
              <div
                className={`${styles.colorBlue} ${styles.loadPhotoInputWrapper}`}
              >
                <div className={`${styles.profileAvatar} mb-1`}>
                  <ModalImage
                    className={`${styles.profileAvatar} mb-1`}
                    small={logo || 'img/users/no-avatar.png'}
                    alt="User Photo"
                  />
                </div>

                <span className={styles.small}>Загрузить фото</span>

                <input
                  type="file"
                  name="photo"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    handleImageChange(event)
                  }
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 mb-3">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 small">
                <input
                  type="radio"
                  name="client_type"
                  id="client_type_1"
                  value="individual"
                  checked={!entity}
                  onChange={handleChange}
                />
                <label className="mr-3" htmlFor="client_type_1">
                  Физлицо
                </label>
                <input
                  type="radio"
                  name="client_type"
                  id="client_type_2"
                  value="legal"
                  checked={entity}
                  onChange={handleChange}
                />
                <label className="mr-3" htmlFor="client_type_2">
                  Юрлицо
                </label>
              </div>

              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 jsUrlico">
                <small className={classNames('mb-1', 'd-block', styles.small2)}>
                  Название клиента*
                </small>
                <input
                  value={entityName}
                  onChange={handleInputChange(setEntityName, 'entityName')}
                  required
                  type="text"
                  placeholder="Наименование"
                  className={errors.entityName ? styles.isError : ''}
                />
              </div>

              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                <small className={classNames('mb-1', 'd-block', styles.small2)}>
                  ФИО
                </small>
                <input
                  value={name}
                  onChange={handleInputChange(setName, 'name')}
                  type="text"
                  placeholder="ФИО"
                  // className={errors.name ? styles.isError : ''}
                />
              </div>

              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                <small className={classNames('mb-1', 'd-block', styles.small2)}>
                  E-mail
                </small>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="text"
                  placeholder="E-mail"
                />
              </div>
            </div>

            <div className={styles.small}>
              <input
                id="client_enable"
                checked={isActive}
                type="checkbox"
                onChange={(e) => {
                  setIsActive(e.target.checked)
                }}
                name="client_enable"
                className={styles.input}
              />
              <label htmlFor="client_enable">Активен</label>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
            <small className={classNames('mb-1', 'd-block', styles.small2)}>
              Договор
            </small>
            <select
              value={selectedContractId === '' ? '' : String(selectedContractId)}
              onChange={(e) => {
                const value = e.target.value
                setSelectedContractId(value === '' ? '' : Number(value))
              }}
              disabled={!contracts?.length}
            >
              {!contracts?.length && (
                <option value="">Нет договоров</option>
              )}
              {contracts.map((contract: Client['contracts'][number]) => (
                <option key={contract.id} value={contract.id}>
                  {contract.number} от {formatDate(contract.date)}
                  {!contract.active ? ' (Закрыт)' : ''}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
            <small className={classNames('mb-1', 'd-block', styles.small2)}>
              Валюта
            </small>
            <select
              onChange={(e) => setCurrency(e.target.value)}
              value={currency}
            >
              {currencies.map((cur) => (
                <option key={cur.value} value={cur.value}>
                  {cur.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-12">
            <div className="mb-2">
              <b>Адрес</b>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
            <small className={classNames('mb-1', 'd-block', styles.small2)}>
              Страна *
            </small>
            <select
              className={errors.countryIso ? styles.isError : ''}
              value={countryIso}
              onChange={(e) => {
                handleSelectChangeCountry(e)
                // @ts-ignore
                setErrors((prevErrors) => ({
                  ...prevErrors,
                  countryIso: false,
                }))
              }}
              required
            >
              <option value="">Выберите страну</option>
              {countries?.map((item) => {
                return (
                  <option key={item.iso} value={item.iso}>
                    {item.name}
                  </option>
                )
              })}
            </select>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
            <small className={classNames('mb-1', 'd-block', styles.small2)}>
              Город *
            </small>
            <select
              className={errors.cityId ? styles.isError : ''}
              value={cityId}
              onChange={(e) => {
                handleSelectChangeCity(e)
                // @ts-ignore
                setErrors((prevErrors) => ({ ...prevErrors, cityId: false }))
              }}
            >
              <option value="">Выберите город</option>
              {cities?.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                )
              })}
            </select>
          </div>

          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
            <small className={classNames('mb-1', 'd-block', styles.small2)}>
              Район
            </small>
            <input
              value={district}
              onChange={handleInputChange(setDistrict, 'district')}
              type="text"
              placeholder="Район города"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
            <small className={classNames('mb-1', 'd-block', styles.small2)}>
              Адрес
            </small>
            <input
              value={address}
              onChange={handleInputChange(setAddress, 'address')}
              type="text"
              placeholder="Адрес загрузки/отгрузки"
            />
          </div>
        </div>

        {currentClientByRequest && (
          <div className="mb-3">
            <div className="mb-2">
              <b>Телефоны</b>
            </div>
            {phones.map((item: Phone) => (
              <div
                className={classNames(
                  'row align-items-center pl-2 pr-2 pt-2 pb-2 mb-4',
                  styles.small3,
                  styles.bxShadowSmall,
                  styles.bgGray,
                  styles.borderRadius5
                )}
              >
                <div
                  className="col-6 pt-1 pl-1 pr-1"
                  style={{ textAlign: 'left' }}
                >
                  <input
                    value={item.number || ''}
                    onChange={(e) =>
                      handleNumberChange(item.id, e.target.value)
                    }
                    required
                    type="text"
                    placeholder="Телефон"
                  />
                </div>
                <div
                  className="col-6 pt-1 pl-1 pr-1"
                  style={{ textAlign: 'left' }}
                >
                  <input
                    type="email"
                    value={item.email || ''}
                    onChange={(e) => handleEmailChange(item.id, e.target.value)}
                    placeholder="E-mail"
                  />
                </div>
                <div
                  className="col-6 pt-1 pl-1 pr-1"
                  style={{ textAlign: 'left' }}
                >
                  <input
                    type="text"
                    value={item.name || ''}
                    onChange={(e) => handleNameChange(item.id, e.target.value)}
                    placeholder="Имя"
                  />
                </div>
                <div
                  className="col-6 pt-1 pl-1 pr-1"
                  style={{ textAlign: 'left' }}
                >
                  <input
                    type="text"
                    value={item.job || ''}
                    onChange={(e) => handleJobChange(item.id, e.target.value)}
                    placeholder="Должность"
                  />
                </div>
                <div
                  className="col-6 pt-1 pl-1 pr-1"
                  style={{ textAlign: 'left' }}
                >
                  {isWasChanged === item.id && (
                    <button
                      onClick={() => handleEditPhone(item)}
                      className={classNames(
                        styles.btn,
                        styles.btnSmall2,

                        styles.btnTrans,
                        styles.btnBlueOutline,
                        'mr-1'
                      )}
                      disabled={!item.number}
                    >
                      <i
                        className={classNames(
                          styles.icon,
                          styles.iconVerified2,
                          styles.iconBlue
                        )}
                      ></i>{' '}
                      Сохранить
                    </button>
                  )}
                </div>
                <div
                  className="col-6 pt-1 pl-1 pr-1"
                  style={{ textAlign: 'right' }}
                >
                  <input
                    type="checkbox"
                    id={`phone_sms_${item.id}`}
                    checked={item.notification}
                    onChange={(e) =>
                      handleNotificationChange(item.id, e.target.checked)
                    }
                  />
                  <label
                    className={styles.labelNotifications}
                    htmlFor={`phone_sms_${item.id}`}
                  >
                    Уведомления
                  </label>
                  <div
                    onClick={() => {
                      dispatch(setVisibleDeleteModalPhone(true))
                      dispatch(setCurrentPhone(item))
                    }}
                    className={classNames(
                      styles.btn,
                      styles.btnSmall2,
                      styles.btnIcon,
                      styles.btnOutline
                    )}
                  >
                    <i
                      className={classNames(
                        styles.icon,
                        styles.icon15,
                        styles.iconDelete
                      )}
                    />
                  </div>
                </div>
              </div>
            ))}
            {isVisibleAddPhone && (
              <div>
                <div
                  className={classNames(
                    'row align-items-center pl-2 pr-2 pt-2 pb-2 mb-4',
                    styles.small3,
                    styles.bxShadowSmall,
                    styles.bgGray,
                    styles.borderRadius5
                  )}
                >
                  <div
                    className="col-6 pt-1 pl-1 pr-1"
                    style={{ textAlign: 'left' }}
                  >
                    <input
                      value={newNumber}
                      onChange={(e) => setNewNumber(e.target.value)}
                      required
                      type="text"
                      placeholder="Телефон"
                    />
                  </div>
                  <div
                    className="col-6 pt-1 pl-1 pr-1"
                    style={{ textAlign: 'left' }}
                  >
                    <input
                      type="email"
                      value={newEmail}
                      onChange={(e) => setNewEmail(e.target.value)}
                      placeholder="E-mail"
                    />
                  </div>
                  <div
                    className="col-6 pt-1 pl-1 pr-1"
                    style={{ textAlign: 'left' }}
                  >
                    <input
                      type="text"
                      value={newName}
                      onChange={(e) => setNewName(e.target.value)}
                      placeholder="Имя"
                    />
                  </div>
                  <div
                    className="col-6 pt-1 pl-1 pr-1"
                    style={{ textAlign: 'left' }}
                  >
                    <input
                      type="text"
                      value={newJob}
                      onChange={(e) => setNewJob(e.target.value)}
                      placeholder="Должность"
                    />
                  </div>
                  <div
                    className="col-6 pt-1 pl-1 pr-1"
                    style={{ textAlign: 'left' }}
                  >
                    <button
                      onClick={handleAddPhone}
                      className={classNames(
                        styles.btn,
                        styles.btnSmall2,
                        styles.btnTrans,
                        styles.btnBlueOutline,
                        'mr-1'
                      )}
                      disabled={!newNumber}
                    >
                      <i
                        className={classNames(
                          styles.icon,
                          styles.iconVerified2,
                          styles.iconBlue
                        )}
                      ></i>{' '}
                      Добавить
                    </button>
                  </div>
                  <div
                    className="col-6 pt-1 pl-1 pr-1"
                    style={{ textAlign: 'right' }}
                  >
                    <input
                      type="checkbox"
                      id={`new_phone_sms`}
                      checked={newNotification}
                      onChange={(e) => setNewNotification(e.target.checked)}
                    />
                    <label
                      className={styles.labelNotifications}
                      htmlFor={`new_phone_sms`}
                    >
                      Уведомления
                    </label>
                  </div>
                </div>
              </div>
            )}

            <button
              onClick={(e) => {
                e.preventDefault()
                setIsVisibleAddPhone((prev) => !prev)
              }}
              className={`${styles.btn} ${styles.btnSmall} ${styles.btnBlueOutline}`}
            >
              {!isVisibleAddPhone ? '+ Добавить' : 'Отмена'}
            </button>
          </div>
        )}
      </div>
    </>
  )
}

const Requisites = ({
  requisitesInn,
  setRequisitesInn,
  requisitesBankBik,
  setRequisitesBankBik,
  requisitesBankSwift,
  setRequisitesBankSwift,
  requisitesBankAccount,
  setRequisitesBankAccount,
  requisitesBankName,
  setRequisitesBankName,
  requisitesAddress,
  requisitesName,
  requisitesFull,
  setRequisitesAddress,
  setRequisitesName,
  setRequisitesFull,
}: any) => {
  const textareaRef = useRef(null)

  useLayoutEffect(() => {
    if (textareaRef.current) {
      //@ts-ignore
      textareaRef.current.style.height = 'inherit'
      //@ts-ignore
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`
    }
  }, [requisitesAddress])

  const textareaRefFull = useRef(null)

  useLayoutEffect(() => {
    if (textareaRefFull.current) {
      //@ts-ignore
      textareaRefFull.current.style.height = 'inherit'
      //@ts-ignore
      textareaRefFull.current.style.height = `${textareaRefFull.current.scrollHeight}px`
    }
  }, [requisitesFull])

  return (
    <div className="mb-5">
      <div className="row">
        <div className="col-12 mb-3">
          <small className="small-2 d-block mb-1">Наименование юрлица</small>
          <input
            value={requisitesName}
            onChange={(e) => setRequisitesName(e.target.value)}
            type="text"
            placeholder="Наименование юрлица"
          />
        </div>

        <div className="col-12 col-sm-8 col-md-8 col-lg-9 col-xl-9 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Номер счета
          </small>
          <input
            value={requisitesBankAccount}
            onChange={(e) => setRequisitesBankAccount(e.target.value)}
            type="text"
            placeholder="Номер счета"
          />
        </div>
        <div className="col-12 col-sm-4 col-md-4 col-lg-3 col-xl-3 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            УНП/ИНН
          </small>
          <input
            value={requisitesInn}
            onChange={(e) => setRequisitesInn(e.target.value)}
            type="text"
            placeholder="УНП/ИНН"
          />
        </div>

        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Банк
          </small>
          <input
            value={requisitesBankName}
            onChange={(e) => setRequisitesBankName(e.target.value)}
            type="text"
            placeholder="Название банка"
          />
        </div>
        <div className="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            SWIFT
          </small>
          <input
            value={requisitesBankSwift}
            onChange={(e) => setRequisitesBankSwift(e.target.value)}
            type="text"
            placeholder="SWIFT"
          />
        </div>
        <div className="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            БИК
          </small>
          <input
            value={requisitesBankBik}
            onChange={(e) => setRequisitesBankBik(e.target.value)}
            type="text"
            placeholder="БИК"
          />
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Юридический адрес
          </small>
          <textarea
            className={styles.rangeValue}
            ref={textareaRef}
            value={requisitesAddress}
            onChange={(e) => setRequisitesAddress(e.target.value)}
            placeholder="Юридический адрес"
          />
        </div>

        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Полные реквизиты
          </small>
          <textarea
            className={styles.rangeValue}
            ref={textareaRefFull}
            value={requisitesFull}
            onChange={(e) => setRequisitesFull(e.target.value)}
            placeholder="Полные реквизиты"
          />
        </div>
      </div>
    </div>
  )
}

function AddClientModal() {
  const dispatch = useDispatch<AppDispatch>()
  const { currentClientByRequest } = useSelector(clientsSelector)
  const { phones: phonesByRequest } = useSelector(phonesSelector)
  useClearBodyNoScrollClass()

  // MAIN INFO

  const [isActive, setIsActive] = useState(
    currentClientByRequest?.active || false
  )
  const [district, setDistrict] = useState('')
  const [address, setAddress] = useState('')
  const [entity, setEntity] = useState(false)
  const [entityName, setEntityName] = useState('')
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phones, setPhones] = useState<Array<Phone>>([])
  const [countryIso, setCountryIso] = useState('')
  const [countryName, setCountryName] = useState('')
  const [cityId, setCityId] = useState<number | string>('')
  const [cityName, setCityName] = useState('')
  const [logo, setLogo] = useState<null | string>(null)
  const [contracts, setContracts] = useState<Client['contracts']>([])
  const [selectedContractId, setSelectedContractId] = useState<number | ''>('')
  const [currency, setCurrency] = useState('BYN')

  const [requisitesInn, setRequisitesInn] = useState('')
  const [requisitesBankBik, setRequisitesBankBik] = useState('')
  const [requisitesBankSwift, setRequisitesBankSwift] = useState('')
  const [requisitesBankAccount, setRequisitesBankAccount] = useState('')
  const [requisitesBankName, setRequisitesBankName] = useState('')
  const [requisitesAddress, setRequisitesAddress] = useState('')
  const [requisitesName, setRequisitesName] = useState('')
  const [requisitesFull, setRequisitesFull] = useState('')

  const [currentTab, setCurrentTab] = useState(1)

  const [selectedImage, setSelectedImage] = useState<any>(null)

  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e?.target?.files?.[0]
    if (!file) return
    try {
      const converted = await convertFileIfHeic(file)
      setSelectedImage(converted)
      setLogo(URL.createObjectURL(converted))
    } catch {
      toast.error(
        'HEIC не поддерживается в этом браузере. Сохраните фото в JPG и загрузите снова.'
      )
    }
  }

  useEffect(() => {
    if (currentClientByRequest) {
      const {
        requisites: {
          inn,
          bank_account,
          bank_bik,
          bank_name,
          bank_swift,
          address,
          name: requisitesName,
          full,
        },
        active,
        district,
        address: addressMain,
        entity,
        entity_name,
        name,
        email,
        country: { iso, name: countryName },
        city: { id: cityId, name: cityName },
        logo,
        contracts,
        currency,
      } = currentClientByRequest

      // MAIN info
      setIsActive(active)
      setDistrict(district)
      setAddress(addressMain)
      setEntity(entity)
      setEntityName(entity_name)
      setName(name)
      setEmail(email)
      setCurrency(currency || 'BYN')
      setContracts(contracts || [])
      const activeContract =
        contracts?.find((contract) => contract.active) ?? contracts?.[0]
      setSelectedContractId(activeContract?.id ?? '')
      setCountryIso(iso)
      setCountryName(countryName)
      setCityId(cityId)
      setCityName(cityName)
      setLogo(logo.original)
      // Requisites
      setRequisitesInn(inn)
      setRequisitesBankBik(bank_bik)
      setRequisitesBankSwift(bank_swift)
      setRequisitesBankAccount(bank_account)
      setRequisitesBankName(bank_name)
      setRequisitesAddress(address)
      setRequisitesName(requisitesName)
      setRequisitesFull(full)
    }
  }, [])

  useEffect(() => {
    setPhones(phonesByRequest)
  }, [phonesByRequest])
  const handleSaveClient = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const commonPayload = {
      isActive,
      district,
      address,
      entity,
      entityName,
      name,
      email,
      phones,
      countryIso,
      countryName,
      cityId,
      cityName,
      logo: selectedImage,
      requisitesInn,
      requisitesBankBik,
      requisitesBankSwift,
      requisitesBankAccount,
      requisitesBankName,
      requisitesAddress,
      requisitesName,
      requisitesFull,
      currency,
      contractId: selectedContractId,
    }

    const newErrors = {
      entityName: !entityName,
      countryIso: !countryIso,
      countryName: !countryName,
      cityId: !cityId,
      cityName: !cityName,
    }

    setErrors(newErrors)

    const hasErrors = Object.values(newErrors).some((error) => error)

    if (!hasErrors) {
      if (currentClientByRequest) {
        dispatch(
          fetchEditClient({ ...commonPayload, id: currentClientByRequest.id })
        )
      } else {
        dispatch(fetchEditClient(commonPayload))
      }
    }
  }

  const renderComponent = () => {
    const mainInfoProps = {
      isActive,
      setIsActive,
      district,
      setDistrict,
      address,
      setAddress,
      entity,
      setEntity,
      entityName,
      setEntityName,
      name,
      setName,
      email,
      setEmail,
      currency,
      setCurrency,
      phones,
      setPhones,
      countryIso,
      setCountryIso,
      countryName,
      setCountryName,
      cityId,
      setCityId,
      cityName,
      setCityName,
      logo,
      setLogo,
      selectedImage,
      setSelectedImage,
      handleImageChange,
      errors,
      setErrors,
      contracts,
      selectedContractId,
      setSelectedContractId,
      currentClientByRequest,
    }

    const requisitesProps = {
      requisitesInn,
      setRequisitesInn,
      requisitesBankBik,
      setRequisitesBankBik,
      requisitesBankSwift,
      setRequisitesBankSwift,
      requisitesBankAccount,
      setRequisitesBankAccount,
      requisitesBankName,
      setRequisitesBankName,
      requisitesAddress,
      setRequisitesAddress,
      requisitesName,
      setRequisitesName,
      requisitesFull,
      setRequisitesFull,
    }

    switch (currentTab) {
      case 1:
        return <MainInfo {...mainInfoProps} />

      case 2:
        return <Requisites {...requisitesProps} />

      default:
        return <MainInfo {...mainInfoProps} />
    }
  }

  useEffect(() => {
    if (currentClientByRequest && currentClientByRequest.id) {
      dispatch(fetchPhones(currentClientByRequest.id))
    }
  }, [])

  // HANDLE ERROR
  const [errors, setErrors] = useState<{
    entityName: boolean
    countryIso: boolean
    countryName: boolean
    cityId: boolean
    cityName: boolean
  }>({
    entityName: false,
    countryIso: false,
    countryName: false,
    cityId: false,
    cityName: false,
  })

  const checkValidation = () => {
    const newErrors = {
      entityName: !entityName,
      countryIso: !countryIso,
      countryName: !countryName,
      cityId: !cityId,
      cityName: !cityName,
    }

    setErrors(newErrors)
  }

  return (
    <div style={{ display: 'block' }} className={styles.win}>
      <div className={styles.winContainer}>
        <div className={styles.winContent}>
          <div
            onClick={() => dispatch(setIsVisibleModalClient(false))}
            className={styles.close}
          >
            ×
          </div>
          <div className={styles.winContentFulltext}>
            <h3
              style={{ textAlign: 'center' }}
              className={classNames(`mb-5 ${styles.h3}}`)}
            >
              {currentClientByRequest
                ? entity
                  ? currentClientByRequest.entity_name
                  : currentClientByRequest.name
                : 'Новый клиент'}
            </h3>
            <div
              className={classNames('row align-items-end', styles.radioTabs)}
            >
              <div
                className={classNames(
                  styles.menuButton,
                  currentTab === 1 ? styles.menuButtonActive : '',
                  'col-6 col-sm-4 col-md-4 mt-2 mb-2'
                )}
                onClick={() => setCurrentTab(1)}
              >
                Основное
              </div>
              <div
                className={classNames(
                  styles.menuButton,
                  currentTab === 2 ? styles.menuButtonActive : '',
                  'col-6 col-sm-4 col-md-4 mt-2 mb-2'
                )}
                onClick={() => setCurrentTab(2)}
              >
                Реквизиты
              </div>
            </div>
            <form onSubmit={handleSaveClient}>
              {renderComponent()}
              <div className="row mt-3">
                <div
                  className="col-12 col-sm-6 mt-1 mb-1"
                  style={{ textAlign: 'left' }}
                >
                  <button
                    onClick={checkValidation}
                    className={classNames(
                      'd-block',
                      'd-sm-inline-block',
                      styles.btn
                    )}
                    type="submit"
                    // disabled={isDisabledButton}
                  >
                    <i className={`${styles.icon} ${styles.iconCheckWhite}`} />{' '}
                    Сохранить
                  </button>
                </div>
                <div
                  className="col-12 col-sm-6 mt-1 mb-1"
                  style={{ textAlign: 'right' }}
                >
                  <div
                    onClick={() => dispatch(setIsVisibleModalClient(false))}
                    className={classNames(
                      'd-block',
                      'd-sm-inline-block',
                      styles.btn,
                      styles.btnSmall,
                      styles.btnBlueOutline
                    )}
                  >
                    Отмена
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddClientModal
